import React from 'react'
import UserDropdown from './utilities/UserDropdown'
import ReferenceDropdown from './utilities/ReferenceDropdown'
import QueueDropdown from './utilities/QueueDropdown'
import { connect } from 'react-redux'
import Datepick from './datepick'
import Statuspick from './statuspick'
import Timepick from './timepick'
import { editEndpointList } from '../actions/endpoints'
// import DatePicker from 'react-datepicker'
import 'moment-timezone'
import moment from 'moment'
import { showMessage } from '../actions/messageBox';


const titleCase = (str) => {
    return str.replace(('_' || '-' || ' _' || '_ ' || '.'), ' ' || '_id', 'id')
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
        .replace('Id', 'ID')
}

class ScheduleForm extends React.Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this)

        this.statusRef = null

    }

    componentDidMount() {
        if (this.props.setRef && typeof this.props.setRef === "function") {
            this.props.setRef(this)
        }
    }

    deactivate() {
        if (this.statusRef && typeof this.statusRef.handleToggle === "function") {
            this.statusRef.handleToggle()
        }
    }

    handleSubmit() {

        let custom_error_count = 0
        let etval = document.getElementById("schedule.end_time_value")
    
        if (etval && etval.classList.contains("is-invalid")) {
            custom_error_count++ 
        }

        if (!custom_error_count && (!this.props.errors || (this.props.errors && Object.keys(this.props.errors).length === 0))) {
            //console.log('this.props.schedule',this.props.schedule)
            // schedule[scheduleProperty] = moment(schedule[scheduleProperty]).format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]')
            this.props.dispatch(editEndpointList(2, "schedules", this.props.accessToken, this.props.schedule))
                .then(respObj => {
                    if (respObj.response.ok) {
                        this.props.dispatch(showMessage({
                            type: "success",
                            title: "Success",
                            message: "Schedule successfully saved"
                        }))
                    }
                })
        } else {

        }
    }

    render() {
        let {
            schedule,
            onChange,
            allowActivate,
            errors,
            endpoints
        } = this.props
        let dateTimeDom = []
        let statusDom = []
        let innerDom = []

        for (let scheduleProperty in schedule) {
            if (scheduleProperty === 'status') {
                statusDom.push(
                    //pre process data
                    <div key={scheduleProperty} className="my-2">
                        <label htmlFor={`schedule.${scheduleProperty}`}> Active </label>
                        <Statuspick
                            setRef={node => { this.statusRef = node }}
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            defaultChecked={schedule.status === 1}
                            className="form-control"
                            status={schedule.status}
                            onChange={onChange}
                            allowActivate={allowActivate}
                            activateError="You cannot activate a schedule for an inactive integration. Please activate the integration first"
                            showText={true}
                        />
                    </div>
                )
            } else if (scheduleProperty === 'start_date') {
                dateTimeDom.push(
                    <div key={scheduleProperty} className="mr-2 mt-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}>{titleCase(scheduleProperty.toUpperCase())}</label>
                        <Datepick
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            className={"form-control" + (errors && errors["start_date"] ? " is-invalid" : "")}
                            selected={Date.parse(schedule.start_date.split(" ")[0])}
                            onChange={onChange}
                            error={errors && errors["start_date"] ? errors["start_date"] : ""}
                        />
                    </div>
                )
            } else if (scheduleProperty === 'end_date') {
                dateTimeDom.push(
                    <div key={scheduleProperty} className="mt-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}>{titleCase(scheduleProperty.toUpperCase())}</label>
                        <Datepick
                            id={`schedule.${scheduleProperty}`}
                            className={"form-control" + (errors && errors["end_date"] ? " is-invalid" : "")}
                            name={`schedule.${scheduleProperty}`}
                            selected={Date.parse(schedule.end_date.split(" ")[0])}
                            onChange={onChange}
                            error={errors && errors["end_date"] ? errors["end_date"] : ""}
                        />
                    </div>
                )

            } else if (scheduleProperty === 'frequency_id') {
                innerDom.push(
                    <div key={scheduleProperty} className="mb-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}> Frequency </label>
                        <ReferenceDropdown
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            endpointName="frequencies"
                            className={"form-control" + (errors && errors["frequency_id"] ? " is-invalid" : "")}
                            value={schedule.frequency_id ? schedule.frequency_id : 0}
                            onChange={onChange}
                            showInactive={true}
                        />
                        <div className="invalid-feedback">
                            {errors && errors["frequency_id"] ? errors["frequency_id"] : ""}
                        </div>
                    </div>
                )
            } else if (scheduleProperty === 'created_by') {
                innerDom.push(
                    <div key={scheduleProperty} className="mb-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}> Created by </label>
                        <UserDropdown
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            endpointName="users"
                            className={"form-control" + (errors && errors["created_by"] ? " is-invalid" : "")}
                            value={schedule.created_by}
                            onChange={onChange}
                            disabled={"disabled"}
                        />
                        <div className="invalid-feedback">
                            {errors && errors["created_by"] ? errors["created_by"] : ""}
                        </div>
                    </div>
                )
            } else if (scheduleProperty === 'updated_by') {
                innerDom.push(
                    <div key={scheduleProperty} className="mb-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}> Updated by </label>
                        <UserDropdown
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            endpointName="users"
                            className={"form-control" + (errors && errors["updated_by"] ? " is-invalid" : "")}
                            value={schedule.updated_by}
                            onChange={onChange}
                            disabled={"disabled"}
                        />
                        <div className="invalid-feedback">
                            {errors && errors["updated_by"] ? errors["updated_by"] : ""}
                        </div>
                    </div>
                )
            } else if (scheduleProperty === 'start_time') {
                dateTimeDom.push(
                    <div key={scheduleProperty} className="mb-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}>{titleCase(scheduleProperty.toUpperCase())}</label>
                        <Timepick
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            selected={schedule.start_time}
                            onChange={onChange}
                            className={"form-control" + (errors && errors["start_time"] ? " is-invalid" : "")}
                            error={errors && errors["start_time"] ? errors["start_time"] : ""}
                        />

                        {/* <input type="time" 
                            id={`schedule.${scheduleProperty}`} 
                            name={`schedule.${scheduleProperty}`}
                            value={displayDate}
                            onChange={onChange}
                        /> */}
                    </div>
                )
            } else if (scheduleProperty === 'end_time') {
                dateTimeDom.push(
                    <div key={scheduleProperty} className="mb-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}>{titleCase(scheduleProperty.toUpperCase())}</label>
                        <Timepick
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            selected={schedule.end_time}
                            onChange={onChange}
                            className={"form-control" + (errors && errors["end_time"] ? " is-invalid" : "")}
                            error={errors && errors["end_time"] ? errors["end_time"] : ""}
                        />                      
                    </div>
                )
            } else if (scheduleProperty === 'queue_no') {
                innerDom.push(
                    <div key={scheduleProperty} className="mb-2" >
                        <label htmlFor={`schedule[${scheduleProperty}]`}>{titleCase(scheduleProperty.toUpperCase())}</label>
                        <QueueDropdown
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            endpointName="queue_no"
                            className={"form-control" + (errors && errors["queue_no"] ? " is-invalid" : "")}
                            value={parseInt(schedule.queue_no)}
                            onChange={onChange}
                        />
                        <div className="invalid-feedback">
                            {errors && errors[scheduleProperty] ? errors[scheduleProperty] : ""}
                        </div>
                    </div>
                )
            } else if (scheduleProperty === "created_at" || scheduleProperty === "updated_at") {
                
                //let displayDate = moment(schedule[scheduleProperty]).format('YYYY-MM-DD HH:mm:ss')
                let displayDate = moment(schedule[scheduleProperty]).format('MM-DD-YYYY HH:mm:ss')
                // console.log("this is date",schedule[scheduleProperty])
                innerDom.push(
                    <div key={scheduleProperty} className="mb-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}>{titleCase(scheduleProperty.toUpperCase())}</label>
                        {/* <input
                            readOnly
                            className={"form-control" + (errors && errors[scheduleProperty] ? " is-invalid" : "")}
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            value={displayDate}
                            onChange={onChange}

                        /> */}
                        <div><label>
                            {displayDate}
                        </label></div>
                        <div className="invalid-feedback">
                            {errors && errors[scheduleProperty] ? errors[scheduleProperty] : ""}
                        </div>
                    </div>
                )

            } else if (
                scheduleProperty === 'id' ||
                scheduleProperty === 'task_id' ||
                scheduleProperty === 'name' ||
                scheduleProperty === 'description' ||
                scheduleProperty === 'priority'
            ) {
                // Skip these fields
            } else {
                innerDom.push(
                    <div key={scheduleProperty} className="mb-2">
                        <label htmlFor={`schedule[${scheduleProperty}]`}>{titleCase(scheduleProperty.toUpperCase())}</label>
                        <input
                            className={"form-control" + (errors && errors[scheduleProperty] ? " is-invalid" : "")}
                            id={`schedule.${scheduleProperty}`}
                            name={`schedule.${scheduleProperty}`}
                            value={schedule[scheduleProperty]}
                            onChange={onChange}
                        />
                        <div className="invalid-feedback">
                            {errors && errors[scheduleProperty] ? errors[scheduleProperty] : ""}
                        </div>
                    </div>
                )
            }
        }

        return (
            <div>
                <div className="fieldmapping margined">
                    <div className="row fieldmap-table-header">
                        <div className="col-12 field-mapping-header-label-wrapper">
                            <div className="row fieldmap-table-toolbar py-1 clearfix">
                                <div className="ml-3 float-left">
                                    <button className="btn" type="button" onClick={this.handleSubmit}>
                                        <i className="fa fa-save fa-fw"></i> Apply
                                    </button>
                                    <span className="helper-text"> * Apply your changes before saving your integration settings</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="px-3 py-2 pb-5" style={{ maxWidth: '400px' }}>
                        {statusDom}
                        <div className="">
                            {dateTimeDom}
                        </div>
                        {innerDom}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        schedule: ownProps.schedule,
        proccessedStartDate: ownProps.proccessedStartDate,
        onChange: ownProps.onChange,
        accessToken: state.auth.access_token,
        sched : state,
        own: ownProps
    }
}

export default connect(mapStateToProps)(ScheduleForm)




// WEBPACK FOOTER //
// ./src/components/scheduleForm.js